module.exports = __webpack_public_path__ + "static/city_step05-496ed3572cec3ce64383572f161a14ef.png";